<template>
    <div class="box box__content--padded">
        <div class="box__header">
            <button @click="$emit('close')" class="c-btn float-right"><span class="icon-delete-ccs icon-ccs"></span></button>
            <h3>{{ entry.short_notice }}</h3>
        </div>
        <div class="box__content">
            <template v-if="entry.tag == 'load2_servers' || entry.tag == 'load10_server'">
                <load-status-modal :server-list="entry.server_list"></load-status-modal>
            </template>
            <template v-else-if="entry.hasOwnProperty('server_list') && entry.server_list.length > 0">
                <server-list-modal :server-list="entry.server_list"></server-list-modal>
            </template>
        </div>
    </div>
</template>

<script>
import LoadStatusModal from "@/components/system-alerts/LoadStatusModal.vue";
import ServerListModal from "@/components/system-alerts/ServerListModal.vue";

export default {
    components: {
        LoadStatusModal,
        ServerListModal
    },
    props: {
        entry: Object
    }
};
</script>
